import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-table-remarks',
  templateUrl: './time-table-remarks.component.html',
  styleUrls: ['./time-table-remarks.component.scss']
})
export class TimeTableRemarksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
